


















import { defineComponent, PropType } from "@vue/composition-api";
import { ImgSource } from "@/views/PageLanding/types";

export default defineComponent({
  name: "CategoryCard",
  props: {
    title: { type: String },
    img: { type: Object as PropType<ImgSource>, required: true },
  },
});
